<template>
	<inertia-head title="Old Members" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Old Members</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						List of old members of TRC
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded mb-1">
			<div class="block-content">
				<form @submit.prevent="submit">
					<div class="row">
						<div class="col-md-6">
							<div class="row">
								<div class="col-md-12">
									<div class="mb-4">
										<label for="expiryDate" class="form-label">
											Expiry Date
										</label>
										<flat-pickr
											v-model="form.date"
											id="expiryDate"
											class="form-control form-control-sm"
											:config="{
												altInput: true,
												altFormat: 'M j, Y',
												dateFormat: 'Y-m-d',
												wrap: true,
												mode: 'range',
											}"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<div class="mb-4">
										<label for="" class="form-label">Filter by</label>
										<select
											v-model="form.filterByColumn"
											class="form-select form-select-sm"
										>
											<option value="email">Email</option>
											<option value="fname">First Name</option>
											<option value="lname">Last Name</option>
											<option value="counter">User ID</option>
										</select>
									</div>
								</div>
								<div class="col-md-6">
									<div class="mb-4">
										<label for="" class="form-label">Value</label>
										<input
											v-model="form.columnValue"
											type="text"
											class="form-control form-control-sm"
										/>
									</div>
								</div>
							</div>
						</div>
						<div class="col space-x-1 mb-4 d-flex align-items-end">
							<button
								type="submit"
								class="btn btn-alt-primary"
								:disabled="form.processing || !form.isDirty"
							>
								Refine Result
							</button>
							<button
								@click="
									$inertia.visit(route('admin.user-management.old-members'))
								"
								type="button"
								class="btn btn-alt-secondary"
							>
								Reset
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="block block-rounded">
			<div class="block-content">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead class="text-center">
							<tr>
								<th>User ID</th>
								<th>Username</th>
								<th>Full Name</th>
								<th>Email</th>
								<th>Expiry Date</th>
							</tr>
						</thead>
						<tbody v-if="oldMembers.data.length > 0" class="fs-sm">
							<tr v-for="oldMember in oldMembers.data" :key="oldMember.id">
								<td>{{ oldMember.id }}</td>
								<td>{{ oldMember.username }}</td>
								<td>{{ oldMember.full_name }}</td>
								<td>{{ oldMember.email }}</td>
								<td>{{ oldMember.expiry }}</td>
							</tr>
						</tbody>
						<tbody v-else class="fs-sm">
							<tr>
								<th colspan="5" class="text-center">NO OLD MEMBER FOUND</th>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- Pagination -->
				<pagination :collections="oldMembers" />
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		oldMembers: Object,
		filters: Object,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const form = useForm({
			date: props.filters.date,
			filterByColumn: props.filters.filterByColumn,
			columnValue: props.filters.columnValue,
		})

		const submit = () => {
			form.get(route('admin.user-management.old-members'), {
				preserveState: true,
				preserveScroll: true,
			})
		}

		return {
			form,
			submit,
		}
	},
}
</script>
